import { styled } from 'stitches.config'
import { Collapsible } from 'components/Collapsible'

export const MobileMenuRoot = styled('div', {
  margin: 0,
  backgroundColor: '$secondary-100',
  alignSelf: 'flex-start',
  width: '100%',
  paddingBottom: '2px',
  transition: 'paddingLeft, paddingRight, paddingTop, 0.3s linear',

  variants: {
    isScrollingDown: {
      true: {
        px: 0,
        paddingTop: 0,
      },
      false: {
        px: '$3',
        paddingTop: '$2',
      },
    },
    isOpen: {
      true: {
        px: 0,
        paddingTop: 0,
      },
    },
  },
  '@bp2': {
    display: 'none',
  },
})

export const Content = styled(Collapsible.Root, {
  backgroundColor: '$secondary-400',
  borderRadius: '$3',
  border: '1px solid $secondary-600',
  boxShadow: '0px 3px 0px $colors$secondary-600',
  overflow: 'auto',
})

export const MobileMenuTrigger = styled(Collapsible.Trigger, {
  border: 'none',
  '& span': {
    flexGrow: 1,
  },
})

export const MobileMenuContent = styled(Collapsible.Content, {
  padding: '0 $2 $2',
  height: `calc(100vh - 100px)`,
  overflow: 'auto',
})

export const MyAccountLink = styled('div', {
  backgroundColor: '$accent-white',
  padding: '12px $3',
  borderRadius: '$4',
  border: '1px solid $secondary-600',
  boxShadow: '0px 3px 0px $colors$secondary-600',

  variants: {
    active: {
      true: {
        backgroundColor: '$secondary-200',
      },
    },
  },
})
